<ng-container *ngFor="let name of names">

    <ng-container *ngIf="name.type === 'image'; then imageTemplate; else fontTemplate"></ng-container>
    <ng-template #imageTemplate>
        <div class="name"><img [src]="name.icon | safeUrl" *ngIf="true" /></div>
    </ng-template>
    <ng-template #fontTemplate>
        <div class="icon"><i class="fa" [ngClass]="name.icon"></i></div>
    </ng-template>

</ng-container>